import { render, staticRenderFns } from "./DetailHeaderBtns.vue?vue&type=template&id=87a82012&scoped=true&"
import script from "./DetailHeaderBtns.vue?vue&type=script&lang=ts&"
export * from "./DetailHeaderBtns.vue?vue&type=script&lang=ts&"
import style0 from "./DetailHeaderBtns.vue?vue&type=style&index=0&id=87a82012&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a82012",
  null
  
)

export default component.exports